export default {
  user: undefined
};
